<template>
  <div id="serviceProviders" class="modal fade" role="dialog">
    <div class="modal-dialog profile-confirm-poup">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header confirmpopup-bgcolor p-0">
          <div class="add-record-title">
            <div>{{ $t('selectServiceProviderBtn') }}</div>
            <div @click="closeModal()" class="close-icon cursor-pointer">
              <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
            </div>
          </div>
        </div>
        <div class="modal-body confirm-body evidences-table" >
          <div class="row m-0 " >
            <div class="col-md-12 add-evidence-header p-0">
                <span class="service-provider">{{$t('serviceProviderSelectLabel')}}</span>
            <div >
             <div class="col-md-6 p-0 service-dropdown ">
            <span class="service-provider-label">{{$t('selectServiceProviderBtn')}}</span>
              <multiselect
                class="service-provider-ellipsis multiselect-single-dropdown mb-38"
                :placeholder="$t('select')"
                label="labName"
                :showLabels="false"
                openDirection="below"
                v-model="selectServiceProvider"
                :options="serviceProvidersList.map(provider => provider.labId)"
                :custom-label="(opt) => serviceProvidersList.find((x) => x.labId === opt).labName || ''"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
            </div>
            </div>
            </div>
            <loader :loadingStatus="loaderStatus"></loader>

          </div>
        </div>

        <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
          <div  class="">
            <button type="button" class="btn emergo-btn cancel-changes" @click="closeModal">{{ $t('cancel') }}</button>
          </div>

          <div  class="">
            <button type="button" class="btn emergo-btn emergo-primary-button submit-button" :disabled="!selectServiceProvider" @click="submit()">{{ $t('submit') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../UIComponents/Loader.vue';
import {
  getLabsData,
} from '../../apis/representationResources';
import { RequestServiceProvider } from '../../apis/evidence';

export default {
  components: {
    Loader,
  },
  props: {
    labsData: Array
  },
  data() {
    return {
      loaderStatus: false,
      selectServiceProvider: '',
      serviceProvidersList: []
    };
  },
  async created() {
    await this.getLabsInfo();
  },
  methods: {
    async submit() {
      this.loaderStatus = true;
      const payload = {
        evidenceType: '', serviceProviderId: this.selectServiceProvider, registrationId: this.labsData[0].productRegistrationId, regulationId: this.labsData[0].regulationId
      };
      const response = await RequestServiceProvider(payload);
      if (response.status === 204) {
        this.loaderStatus = false;
        this.selectServiceProvider = '';
        this.$emit('loadLabsData');
        this.closeModal();
      }
    },
    async getLabsInfo() {
      this.loaderStatus = true;
      this.serviceProvidersList = await getLabsData('');
      this.loaderStatus = false;
    },
    closeModal() {
      this.selectServiceProvider = '';
      $('#serviceProviders').modal('hide');
    },
  },
};
</script>

<style scoped>
.cancel-changes,
.cancel-changes:hover {
    background-color: #FFF;
    height: 44px;
    min-width: 90px;
    color: #000 !important;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    line-height: 25px;
    float: right;
    cursor: pointer;
    padding: 9px 16px;
    border: 1px solid #000001;
}
.submit-button,
.submit-button:hover {
   height: 44px;
  min-width: 90px;
}
.modal-header {
    background-color: #ffffff !important;
    border-bottom: 1px solid #d3d3d3 !important;
    border-top-right-radius: 6px!important;
    border-top-left-radius: 6px!important;
}
.modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    background-color: #ffffff !important;
}

.add-record-title {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
    color: #3E3E3E;
    padding: 17px 0px 16px 16px;
}
.close-icon {
    padding-right: 20px;
}

.modal-body {
    padding: 32px 70px 0px 40px;
    min-height: 380px;
}

.modal-footer {
    background-color: #fff !important;
    padding-right: 0px;
    border: none !important;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}
.modal-content {
 border: none;
 border-top-right-radius: 6px!important;
 border-top-left-radius: 6px!important;
 border-bottom-right-radius: 0!important;
 border-bottom-left-radius: 0!important;
}

@media (min-width: 768px) {
.modal-dialog {
 width: 820px;
 margin: 30px auto;
}
}
.modal-open .modal {
    overflow-x: hidden;
    overflow-y: hidden;
}

.service-provider {
    color: #3E3E3E;
    font-size: 18px;
    font-weight: 600;
}
.service-dropdown {
  margin-top: 24px;
  padding-left:14px

}
.service-provider-label {
  color: #3E3E3E;
  font-size: 16px;
  font-weight: 400;
}
.submit-button {
  font-size: 18px !important;
}

  .multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
  cursor: not-allowed;
}

.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
  margin-top: 8px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 44px;
    /* padding: 9px 40px 11px 11px; */
    padding: 11px 40px 9px 16px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 13px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top: 4px !important;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999;
    overflow: visible;
    padding:0px
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
  .service-provider-ellipsis.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select {
    padding-top: 0px !important;
  }
   .service-provider-ellipsis.multiselect-single-dropdown
  {
    width: 100%;
  }
   .service-provider-ellipsis.multiselect-single-dropdown >>> .multiselect__single
 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-bottom: 0px;
  }
</style>
